import {
  Box,
  Divider,
  styled,
  useTheme
} from '@mui/material';
import { GeneralSidebarMenu, ManagementSidebarMenu } from './SidebarMenu';

import Logo from '../../../icons/siriusNameLogo.svg';
import { ROUTE_PERMISSIONS } from '../../../core/constants';
import React from 'react';
import Scrollbar from '../../../components/Scrollbar';
import { hasAccess } from '../../../core/PermissionHandler';
import useAuth from 'src/hooks/useAuth';

const SidebarWrapper = styled(Box)(
  ({ theme }) => `
        width: ${theme.sidebar.width};
        min-width: ${theme.sidebar.width};
        color: ${theme.colors.alpha.trueWhite[70]};
        position: relative;
        z-index: 7;
        height: 100%;
        padding-bottom: 65px;
`
);

function Sidebar() {
  const theme = useTheme();
  const auth = useAuth();
  if (auth.isAuthenticated || sessionStorage.getItem("IsAuthenticated") === "true") {
    const hasAccessForManagement = hasAccess(ROUTE_PERMISSIONS.management);

    return (
      <SidebarWrapper
        sx={{
          display: {
            lg: 'inline-block'
          },
          position: 'fixed',
          left: 0,
          top: 0,
          background: '#121731',
          boxShadow:
            theme.palette.mode === 'dark' ? theme.sidebar.boxShadow : 'none'
        }}
      >
        <Scrollbar
          style={{
            height: '100vh'
          }}>
          <Box
            sx={{
              height: 130,
              padding: '5px',
              flexDirection: 'column'
            }}
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <img alt="logo" src={Logo} />
            {/* <Typography>Cloud Video </Typography> 
             <Typography> Exchange</Typography>  */}
          </Box>

          <Divider
            sx={{
              background: theme.colors.alpha.trueWhite[10]
            }}
          />
          <GeneralSidebarMenu />

          {hasAccessForManagement ? (<ManagementSidebarMenu />) : (<></>)}
        </Scrollbar>
      </SidebarWrapper>


    );
  }

  return (<>
    <div>
      <p>AAAAAAAAAAAAAAAAAAA</p>
    </div>
  </>);
}

export default Sidebar;
